<template>
  <div>
    <Head title="Reporte" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/orders">Pedidos</Link>
      <span class="text-sky-400 font-medium">/</span> Resumen de productos
    </h1>

    <div class="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-6">
      <div class="mb-6 flex justify-between">
        <h2 class="text-2xl font-semibold">Pedido del dia: {{ generalResume.date }}</h2>
        <button 
          class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300"
          @click="descargarPDF()"                
        >
          Imprimir Reporte
        </button>
      </div>
      <div class="overflow-x-auto">
        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead>
            <tr class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              <th class="py-3 px-6 text-left">Código</th>
              <th class="py-3 px-6 text-left">Descripción</th>
              <th class="py-3 px-6 text-left">Unidad</th>
              <th class="py-3 px-6 text-left">Cantidad</th>
            </tr>
          </thead>
          <tbody class="text-gray-700 text-sm font-light">
            <tr 
              v-for="(product, index) in generalResume.data" :key="index" 
              class="border-b border-gray-200 hover:bg-gray-100" 
            >
              <td class="py-3 px-6 text-left whitespace-nowrap">{{ product.code }}</td>
              <td class="py-3 px-6 text-left whitespace-nowrap">{{ product.description }}</td>
              <td class="py-3 px-6 text-left">{{ product.unit }}</td>
              <td class="py-3 px-6 text-left">{{ product.total_amount }}</td>
            </tr>            
          </tbody>
          <tfoot>
            <tr class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              <th class="py-3 px-6 text-left">&nbsp;</th>
              <th class="py-3 px-6 text-left">&nbsp;</th>
              <th class="py-3 px-6 text-left">Total cajas</th>
              <th class="py-3 px-6 text-left">{{ generalCount }}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    generalResume: {
      type: Object,
      required: true,
    },
    dateSimple:{
      type: String,
      required: true,
    },
  },
  data() {
    return {
      generalCount: this.generalResume.data.reduce((total, el) => total + Number(el.total_amount), 0),
    }
  },
  watch: {

  },
  methods: {
    descargarPDF() {
      window.location.href = `/orders/report-by-product-pdf/${this.dateSimple}`      
    },
  },
}
</script>